import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';
import logger from '../../utils/logger';

class BookingAlertsService {
  fetchAlerts = async (
    page = 1,
    pageSize = 10,
    status = '',
    tripId = '',
    shipmentId = '',
    tripShipmentId = '',
    fromDate = '',
    toDate = '',
  ) => {
    try {
      let url = `${BASE_URL}/v1/alerts/bookingalerts/?page=${page}&pageSize=${pageSize}`;

      // Backend expects 'status' parameter, not 'alert_type'
      if (status) {
        url += `&status=${encodeURIComponent(status)}`;
      }

      // Add tripId filter
      if (tripId) {
        url += `&tripId=${encodeURIComponent(tripId)}`;
      }

      // Add shipmentId filter
      if (shipmentId) {
        url += `&shipmentId=${encodeURIComponent(shipmentId)}`;
      }

      // Add tripShipmentId filter
      if (tripShipmentId) {
        url += `&tripShipmentId=${encodeURIComponent(tripShipmentId)}`;
      }

      // Add from_date filter (YYYY-MM-DD format)
      if (fromDate) {
        url += `&from_date=${encodeURIComponent(fromDate)}`;
      }

      // Add to_date filter (YYYY-MM-DD format)
      if (toDate) {
        url += `&to_date=${encodeURIComponent(toDate)}`;
      }

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      logger.error('Error fetching booking alerts:', error);
      throw error;
    }
  };
}

const bookingAlertsService = new BookingAlertsService();
export default bookingAlertsService;
